import React, { useEffect, useState, useContext } from 'react'
import getConfig from 'next/config'
import Link from 'next/link'
import { setPageViewData } from '../../utils/analytics'
import StoreListItem from '../../components/StoreListItem'
import { useUnauthAPI } from '../../hooks/api.hooks'
import Context from '../../context'
import AEMContent, { AEMPageType } from '../../components/AEMContent'

const State = ({ stores: initialStores, state, storeLocatorTemplate }) => {
  const [stores, setStores] = useState(initialStores)
  const { state: appState } = useContext(Context)
  const makeAPICall = useUnauthAPI()

  useEffect(() => {
    setPageViewData(`store-directory|${state.toLowerCase()}`, 'Store', state.toLowerCase())
  }, [])

  useEffect(() => {
    if (appState.googleLoaded && appState.location?.lat && appState.location?.lng) {
      makeAPICall('stores', 'store', 'GET', {
        lat: appState.location.lat,
        lng: appState.location.lng,
        state: state
      }, {}).then((data) => data.length && setStores(data))
    }
  }, [appState.googleLoaded, appState.location])

  const renderContent = () => {
    return stores.map((store) => {
      return <StoreListItem key={store.storenumber} store={store} showDistanceLabel={false} />
    })
  }

  return (
    <section className="locations-list">
      <section>
        <div className="locations__heading">
          <h1>pOpshelf locations</h1>
          <nav className="locations__heading-nav" aria-label="Breadcrumb">
            <div className="breadcrumb__element">
              <Link href="/stores">Select a state </Link>
              <p><span className="breadcrumb__separator"> &gt; </span>{(state)?.toUpperCase()}</p>
            </div>
          </nav>
        </div>
      </section>
      <div className="locations-list__stores-container">
        {stores.length && renderContent()}
      </div>
      <div className="locations-list__aem-content">
        <AEMContent template={storeLocatorTemplate} page={AEMPageType.stores} />
      </div>
    </section>
  )
}
export default State
export const getServerSideProps = async ({ params }) => {
  const { publicRuntimeConfig } = getConfig()
  const storesRes = await fetch(`${publicRuntimeConfig.APP_ENDPOINT}/api/stores/${publicRuntimeConfig.ENV}/store?popkey=${publicRuntimeConfig.POP_KEY}&state=${params.state}`)
  const stores = await storesRes.json()
  const state = stores[0].state

  const aemRes = await fetch(
    `${publicRuntimeConfig.APP_ENDPOINT}/api/stores/${publicRuntimeConfig.ENV}/store-locator-template?popkey=${publicRuntimeConfig.POP_KEY}`,
    {
      headers: {
        'X-Pop-App-Token': publicRuntimeConfig.POP_TOKEN_WEB
      }
    }
  )
  const aemData = await aemRes.json()
  const storeLocatorData = aemData.data.store_locator || []
  const responsiveGrid = storeLocatorData.find(item => item.type === 'responsive-grid')

  return {
    props: {
      stores,
      state,
      storeLocatorTemplate: responsiveGrid?.template || []
    }
  }
}
